module.exports = __webpack_public_path__ + "static/img/ic-top-client.6d13a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-top-client.png
// module id = U0Ec
// module chunks = 1